import type { ScreenerSubField } from "epsm-api-types/models";

export const getFirstNestedSubfield = (
	subfields: ScreenerSubField[],
	parentPath = "",
): string => {
	if (!Array.isArray(subfields) || !subfields.length) {
		return "";
	}

	for (const subfield of subfields) {
		const fullPath = parentPath
			? `${parentPath}.${subfield.name}`
			: subfield.name;

		if (
			subfield.subFields &&
			Array.isArray(subfield.subFields) &&
			subfield.subFields.length
		) {
			return getFirstNestedSubfield(subfield.subFields, fullPath);
		}

		return fullPath;
	}

	return "";
};
